import { useState, useEffect } from "react";
import { useCartStore } from "../../../../store/useCartStore";

function Add_to_cart_section2({ product, addToCart, removeFromCart }) {
  const cart = useCartStore((state) => state.cart);
  const [count, setCount] = useState(0);

  // const [cartItems, setCartItems] = useState([]);
  // if (count < 1) {
  // 	remove_from_cart(props.product_id);
  // }
  // function add_to_cart(id) {
  //   props.addToCart({ ...props.product });
  //   document.getElementById(id).style.display = "none";
  //   document.getElementById(id).parentElement.classList.add("active");
  // }
  // function remove_from_cart(id) {
  // removeItem({ ...props.product_id });
  // document.getElementById(id).style.display = "block";
  // document.getElementById(id).parentElement.classList.remove("active");
  //}

  // const addToCart = (item) => {
  // 	setCartItems([...cartItems, item]);

  // };

  useEffect(() => {
    if (cart) {
      const item = cart.filter((i) => i.product_id === product.product_id);
      setCount(item[0]?.count || 0);
    }
    // document.querySelector("#main .mainHeader .buttons a span").innerText = cart_count;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart]);

  return (
    <div className={`add-to-cart ${count > 0 ? "active" : ""}`}>
      {count < 1 ? (
        <p
          // style={{ display: "none" }}
          id={product.product_id}
          onClick={() => {
            addToCart({ ...product });
          }}
        >
          افزودن
        </p>
      ) : (
        <div className="quantity" style={{ display: "block" }}>
          <span
            className="plus"
            onClick={() => {
              addToCart({ ...product });
            }}
          >
            <i className="fas fa-plus"></i>
          </span>
          <input
            className="count"
            value={count || 1}
            min="1"
            type="number"
            onChange={(e) => setCount(e.target.value)}
            readOnly
          />
          <span
            className="minus"
            onClick={() => {
              removeFromCart({ ...product });
            }}
          >
            <i className="fas fa-minus"></i>
          </span>
        </div>
      )}
    </div>
  );
}

export default Add_to_cart_section2;
